/**
 * ChartWidget — Market Monitor "Chart" widget (Amendment A: each chart is
 * its own widget, no chart-row container).
 *
 * Reads its title/period/tags from props.config (a ChartWidgetConfig) and
 * forwards mutations to the ChartController supplied by the dashboard
 * provider. The body is a single MonitorChart slot.
 */

import React from 'react';

import type { WidgetInstanceProps } from '../../../components/grid-dashboard';
import { MonitorChart } from '../dashboard/MonitorChart';
import dashboardStyles from '../dashboard/MonitorDashboard.module.css';
import {
  isChartConfig,
  type ChartWidgetConfig,
} from './chartConfig';
import { useChartController } from './ChartController';

export const ChartWidget: React.FC<WidgetInstanceProps> = ({
  instanceId,
  config,
}) => {
  const controller = useChartController(instanceId);

  const safeConfig: ChartWidgetConfig = isChartConfig(config)
    ? config
    : { chartId: '', title: 'Chart', period: '3Y', tags: [] };

  return (
    <div
      className={dashboardStyles.charts}
      data-testid="chart-widget"
      data-instance-id={instanceId}
    >
      <MonitorChart
        chartIndex={0}
        title={safeConfig.title}
        period={safeConfig.period}
        tags={safeConfig.tags}
        onTitleChange={(title) => controller.setTitle(title)}
        onPeriodChange={(period) => controller.setPeriod(period)}
        onTagsChange={(tags) => controller.setTags(tags)}
        pinned={controller.pinned}
        onTogglePin={() => controller.togglePin()}
        onRemove={() => controller.remove()}
      />
    </div>
  );
};

export default ChartWidget;
